import React, { useEffect } from 'react';
import { initializeHostedFeedbackWidget } from '../services/hostedFeedbackWidget';

export const HelpWidget: React.FC = () => {
  useEffect(() => {
    let controller: { destroy: () => void } | undefined;
    let cancelled = false;

    initializeHostedFeedbackWidget()
      .then((initializedController) => {
        if (cancelled) {
          initializedController.destroy();
          return;
        }
        controller = initializedController;
      })
      .catch((error) => {
        console.error('Unable to initialize the feedback widget.', error);
      });

    return () => {
      cancelled = true;
      controller?.destroy();
    };
  }, []);

  return null;
};

export default HelpWidget;
